import { WaitingListFormValues } from 'hooks/patient/waitingList/useWaitingList';
import { BookingSlot } from 'hooks/site/useSiteHourRange';
import { useFieldArray } from 'react-hook-form';
import { WaitingListRow } from './WaitingListRow';

export type WaitingListRowsProps = {
  slots: BookingSlot[];
  closeHour: number;
  minDate: Date;
  maxDate: Date;
  isDayAvailable: (date: Date) => boolean;
};

export const WaitingListRows = (props: WaitingListRowsProps) => {
  const { fields } = useFieldArray<WaitingListFormValues>({ name: 'list' });

  return (
    <div data-testid={'waitingListRows'}>
      {fields.map(({ id }, index) => (
        <WaitingListRow key={id} index={index} {...props} />
      ))}
    </div>
  );
};
